import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type Brand = {
  name: string;
  tagline: string;
  supportEmail: string;
  logoUrl: string;
};

export type Ads = {
  enabled: boolean;
  message: string;
  ctaLabel: string;
  ctaUrl: string;
};

export type Plan = {
  id: string;
  name: string;
  price: string;
  period: string;
  features: string[];
  highlight?: boolean;
  priceId?: string;
  productId?: string;
};

const defaultBrand: Brand = {
  name: "Nihongo",
  tagline: "Master Japanese",
  supportEmail: "",
  logoUrl: "",
};

const defaultAds: Ads = { enabled: false, message: "", ctaLabel: "", ctaUrl: "" };

const defaultPlans: Plan[] = [
  { id: "free", name: "Free", price: "$0", period: "forever", features: ["5 generations / day", "Basic SEO", "Limited history"] },
  { id: "plus", name: "Plus", price: "$9", period: "/month", features: ["200 generations / month", "Faster AI", "Full history", "Export"], priceId: "plus_monthly", productId: "plus_plan" },
  { id: "pro", name: "Pro", price: "$19", period: "/month", features: ["500+ generations / month", "Priority speed", "Advanced SEO", "Bulk generation", "Exports (CSV)"], highlight: true, priceId: "pro_monthly", productId: "pro_plan" },
];

export function useAppSettings() {
  const [brand, setBrand] = useState<Brand>(defaultBrand);
  const [ads, setAds] = useState<Ads>(defaultAds);
  const [plans, setPlans] = useState<Plan[]>(defaultPlans);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("app_settings")
        .select("key,value")
        .in("key", ["brand", "ads", "plans"]);
      if (cancelled) return;
      if (data) {
        for (const row of data) {
          const v: any = row.value ?? {};
          if (row.key === "brand") setBrand({ ...defaultBrand, ...v });
          if (row.key === "ads") setAds({ ...defaultAds, ...v });
          if (row.key === "plans" && Array.isArray(v) && v.length) setPlans(v as Plan[]);
        }
      }
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { brand, ads, plans, loading };
}
